var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.833008 3.32812H15.9437V4.39788H0.833008V3.32812Z",
    fill: "#9C9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9437 1.93764C15.9437 1.05285 15.2208 0.333008 14.3324 0.333008H2.44434C1.55585 0.333008 0.833008 1.05285 0.833008 1.93764V2.25857H15.9437V1.93764Z",
    fill: "#9C9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9079 6.93997C15.9198 6.93997 15.9317 6.94033 15.9437 6.94043V5.46777H0.833008V9.85377C0.833008 10.7386 1.55585 11.4584 2.44434 11.4584H11.5801C11.577 11.3909 11.5752 11.323 11.5752 11.2547C11.5752 8.87551 13.5188 6.93997 15.9079 6.93997ZM3.51856 6.53753H4.86133C5.15796 6.53753 5.39844 6.77701 5.39844 7.07241C5.39844 7.3678 5.15796 7.60728 4.86133 7.60728H3.51856C3.22193 7.60728 2.98145 7.3678 2.98145 7.07241C2.98145 6.77701 3.22193 6.53753 3.51856 6.53753ZM6.56218 9.31886H3.51856C3.22193 9.31886 2.98145 9.07937 2.98145 8.78398C2.98145 8.48858 3.22193 8.2491 3.51856 8.2491H6.56218C6.8588 8.2491 7.09929 8.48858 7.09929 8.78398C7.09929 9.07937 6.8588 9.31886 6.56218 9.31886Z",
    fill: "#9C9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.9079 8.00977C14.1111 8.00977 12.6494 9.46545 12.6494 11.2547C12.6494 13.044 14.1112 14.4996 15.9079 14.4996C17.7046 14.4996 19.1663 13.0439 19.1663 11.2547C19.1663 9.46545 17.7046 8.00977 15.9079 8.00977ZM17.4693 10.9793L16.1803 12.263C16.0754 12.3675 15.9379 12.4197 15.8005 12.4197C15.6631 12.4197 15.5256 12.3675 15.4207 12.263L14.7583 11.6033C14.5485 11.3944 14.5485 11.0558 14.7583 10.8469C14.968 10.638 15.3081 10.638 15.5179 10.8469L15.8005 11.1284L16.7098 10.2229C16.9195 10.014 17.2596 10.014 17.4694 10.2229C17.6791 10.4318 17.6791 10.7704 17.4693 10.9793Z",
    fill: "#9C9EA9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditFill);
export default __webpack_public_path__ + "static/media/creditFill.b5f246a2e2c6ab854d841ec04a156341.svg";
export { ForwardRef as ReactComponent };